import * as types from './constants';

// Delete Promotion
export const deletePromotionRequest = data => (
  { type: types.DELETE_PROMOTION_REQUEST, payload: data }
);

export const deletePromotionDone = data => (
  { type: types.DELETE_PROMOTION_DONE, payload: data }
);

export const deletePromotionFailed = errors => (
  { type: types.DELETE_PROMOTION_FAILED, payload: errors }
);